import React, { FunctionComponent, memo } from "react";
import {
  Icon,
  IconProps,
  SpaceProps,
} from "@chakra-ui/react";
import { MdCloudOff } from "react-icons/md";


interface IProps extends SpaceProps, IconProps {
}


const LiveDataIndicator: FunctionComponent<IProps> = memo(function LiveDataIndicator({
  ...rest
}) {
  return (
    <Icon
      as={MdCloudOff}
      {...rest}
    />
  );
});

export default LiveDataIndicator;
